import React from "react";
import SingleChat from "./SingleChat";

const MessageSection = ({ fetchAgain, setFetchAgain }) => {
  return (
    <>
      <SingleChat fetchAgain={fetchAgain} setFetchAgain={setFetchAgain} />
    </>
  );
};

export default MessageSection;
